
import Vue, { PropType } from 'vue'
import MenuEntity, { IMenuProps } from '@/entities/Menu'

const component = Vue.extend({
  props: {
    value: {
      type: Object as PropType<IMenuProps>,
      default: null
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    m(value?: IMenuProps): MenuEntity {
      return new MenuEntity(value)
    },
    click(value: IMenuProps) {
      if (this.m(value).href) {
        window.open(this.m(value).href, this.m(value).target)
      } else {
        this.$router.push(this.m(value).to)
      }
    }
  }
})
Vue.component('AMenuSubItem', component)
export default component
